import React from 'react';
import { Image } from '../../../shared/src/components/Image';
import { useDispatch } from 'react-redux';
import { useAsgActions } from '../../../shared/src/hooks/use-asg-actions.hook';

export const GameItem = ({ onOpenGame, data }) => {
    const dispatch = useDispatch();
    const { closeAndLoadGame } = useAsgActions();

    /**
     * open game by game id and game mode
     */
    const openGame = () => {
        dispatch(closeAndLoadGame({
            gameId: data.id,
            mode: 'M',
        }));
    };

    return <div key={data.id} className="game__item">
        <Image
            onClickHandler={() => {
                openGame();
                onOpenGame(data);
            }}
            className="game-item__image"
            images={data.images}
        />
        <div className="game-item__text-wrapper">
            <div  className="game-item__name">
                {data.name}
            </div>
            <div className="game-item__provider-name">
                {data.externalGameSubProvider || data.externalGameProvider}
            </div>
        </div>
        <div
            onClick={() => {
                openGame();
                onOpenGame(data);
            }}
            className="game-item__play-button-wrapper"
        >
            <div className="game-item__play-button" />
        </div>
    </div>;
};
